import IssuesModule from "./issues";
import TopicsModule from "./topics";
import TopicGroupsModule from "./topic_groups";
import TextModule from "./text";

export default [IssuesModule, TopicsModule, TopicGroupsModule, TextModule];
